<template>
  <p :class="[$style.icon, $style['icon_' + iconName]]" />
</template>
<script>
export default {
  name: "tipIcon",
  props: {
    //名称
    iconName: String
  }
};
</script>
<style lang="less" module>
.icon {
  .size(0.87rem);
  background: url("../images/icon-tip.png") no-repeat;
  background-size: 700% 100%;
  margin-right: 0.36rem;
  &_open {
    background-position: 0% 0%;
  }
  &_tel {
    background-position: 16.6% 0%;
  }
  &_key {
    background-position: 33.3% 0%;
  }
  &_security {
    background-position: 40% 0%;
  }
  &_wait {
    background-position: 66.5% 0%;
  }
  &_cry {
    background-position: 83.1% 0%;
  }
  &_small {
    background-position: 99.8% 0%;
  }
}
</style>
